import { parseRelativeUrl } from "next/dist/shared/lib/router/utils/parse-relative-url";
import { useRouter } from "next/router";
import { useCallback, useMemo } from "react";

const DEFAULT_PAGE_NUMBER = 1;

export const usePagination = () => {
  const { query, asPath, push } = useRouter();
  const currentPage = useMemo(
    () => Number(query.p || DEFAULT_PAGE_NUMBER),
    [query]
  );

  const navigate = useCallback(
    (p: number) => {
      const url = parseRelativeUrl(asPath);

      if (p === 1) {
        delete url.query.p;
      } else {
        url.query.p = String(p);
      }

      push({
        pathname: url.pathname,
        query: url.query,
      });
    },
    [asPath]
  );

  return {
    currentPage,
    navigate,
  };
};
